export default __webpack_public_path__ + "locales/sk/JavascriptSdk.json?hash=200a9f4e635640b0bf61719c1dae67b9";